import { RowCrudStatus } from "../../common/types";
import {
  EditionDocumentType,
  EditionDocumentTypeCreateMutationVariables,
  EditionDocumentTypeUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";

export type EditionDocumentTypeValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
};

export type EditionDocumentTypeErrorsType = {
  name?: { message: string; fieldLabel: string };
};

export function EditionDocumentTypeValuesInit(): EditionDocumentTypeValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
  };
}

export type EditionDocumentTypeType =
  | EditionDocumentType
  | EditionDocumentTypeValuesType;

export function editionDocumentTypeDisplayId(
  source: Partial<EditionDocumentType>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getEditionDocumentTypeValues(
  source: EditionDocumentTypeType,
  _langStore: LangStore,
  _duplicated: boolean = false
): EditionDocumentTypeValuesType {
  const entityValues = EditionDocumentTypeValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : editionDocumentTypeDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getEditionDocumentTypeUpdateVariables(
  values: EditionDocumentTypeValuesType
): EditionDocumentTypeUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
  };
}

export function getEditionDocumentTypeCreateVariables(
  values: EditionDocumentTypeValuesType
): EditionDocumentTypeCreateMutationVariables {
  return {
    name: values.name,
  };
}
